import { render, staticRenderFns } from "./ByProduct.vue?vue&type=template&id=09fb0fa9&scoped=true&"
import script from "./ByProduct.vue?vue&type=script&lang=js&"
export * from "./ByProduct.vue?vue&type=script&lang=js&"
import style0 from "./ByProduct.vue?vue&type=style&index=0&id=09fb0fa9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fb0fa9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
